import { Component } from '@angular/core';
import { getBrandDataQuery } from '../../services/product-queries/get-brand-data';
import { ShopifyStorefrontService } from '../../services/shopify-storefront.service';

@Component({
  selector: 'app-privacy-policy',
  imports: [],
  templateUrl: './privacy-policy.component.html',
  styleUrl: './privacy-policy.component.scss',
})
export class PrivacyPolicyComponent {
  constructor(private data: ShopifyStorefrontService) {}
  brandData: any = null;
  ngOnInit() {
    this.data.genericQuery(getBrandDataQuery, {}).subscribe((res: any) => {
      this.brandData = res?.data?.shop;
      console.log('brandData', this.brandData);
    });
  }
}
